var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xl:w-[1100px] pt-[80px] mx-auto"},[_c('h2',{staticClass:"text-2xl text-left font-bold"},[_vm._v("ค้นหาขั้นสูง")]),_c('AdvanceSearchForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }